export default "__VITE_ASSET__zIyyrFmv__"